var _path, _path2, _path3, _path4, _path5;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClock2 = function SvgClock2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 26C4 14.9543 12.9543 6 24 6C35.0457 6 44 14.9543 44 26C44 37.0457 35.0457 46 24 46C12.9543 46 4 37.0457 4 26ZM24 10C15.1634 10 8 17.1634 8 26C8 34.8366 15.1634 42 24 42C32.8366 42 40 34.8366 40 26C40 17.1634 32.8366 10 24 10Z",
    fill: "#082244"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4142 2.58579C13.1953 3.36683 13.1953 4.63317 12.4142 5.41421L5.41421 12.4142C4.63317 13.1953 3.36683 13.1953 2.58579 12.4142C1.80474 11.6332 1.80474 10.3668 2.58579 9.58579L9.58579 2.58579C10.3668 1.80474 11.6332 1.80474 12.4142 2.58579Z",
    fill: "#082244"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5858 2.58579C34.8047 3.36683 34.8047 4.63317 35.5858 5.41421L42.5858 12.4142C43.3668 13.1953 44.6332 13.1953 45.4142 12.4142C46.1953 11.6332 46.1953 10.3668 45.4142 9.58579L38.4142 2.58579C37.6332 1.80474 36.3668 1.80474 35.5858 2.58579Z",
    fill: "#082244"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 14C25.1046 14 26 14.8954 26 16V26C26 27.1046 25.1046 28 24 28C22.8954 28 22 27.1046 22 26V16C22 14.8954 22.8954 14 24 14Z",
    fill: "#082244"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 26C15 24.8954 15.8954 24 17 24H24C25.1046 24 26 24.8954 26 26C26 27.1046 25.1046 28 24 28H17C15.8954 28 15 27.1046 15 26Z",
    fill: "#082244"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock-2.ee3f93d9.svg";
export { ForwardRef as ReactComponent };